import ScrollView from "../../components/ScrollView/ScrollView"
import TitleBorderLeft from "../../components/Text/TitleBorderLeft"
import BorderLeftBox from "../../components/boxes/BorderLeftBox"
import CardThree from "../../components/cards/CardThree"
import TabsViewFour from "../../components/tabs/TabsViewFour/TabsViewFour"
import businessPageData from "../../data/english/subpages/business-page-data"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const BusinessStartegyPage = () => {
  return (
    <main className="page" id="main">
    <div className="sticky-view-two">
      <div className="sticky-container">
        <MainHeader
          title=""
          image={{
            src : require(`../../assets/images/wallpaper/${businessPageData.header.image.name}`),
            alt : businessPageData.header.image.alt,
          }}
        />
      </div>
      <div className="sticky-container-two">
        <div className="wrapper-small">
          <h1 className="title-center">{businessPageData.mainTitle}</h1>
          <p className="text-paragraph">{businessPageData.paragraphOne}</p>
          <div className="space-50"></div>
          <BorderLeftBox 
            title={businessPageData.borderLeftBox.title}
            subtitle={businessPageData.borderLeftBox.subtitle}
          />
        </div>
        <div className="wrapper-larg">
          <ScrollView>
            {businessPageData.cardsOne.map((item, index) => (
              <CardThree 
                key={index}
                icon={{
                  src : require(`../../assets/icons/business/${item.icon.name}`),
                  alt : item.icon.alt,
                }}
                subtitle={item.subtitle}
              />
            ))}
          </ScrollView>
          <div className="space-50"></div>
        </div>
        <div className="wrapper-small">
          <p className="text-paragraph">{businessPageData.paragraphTwo}</p>
          <div className="space-50"></div>
          <TitleBorderLeft>{businessPageData.borderLeftTitle}</TitleBorderLeft>
          <div className="space-50"></div>
          <ScrollView>
            {businessPageData.cardsTwo.map((item, index) => (
              <CardThree 
                key={index}
                title={item.title}
                list={item.list}
                icon={{
                  src : require(`../../assets/icons/business/${item.icon.name}`),
                  alt : item.icon.name,
                }}
              />
            ))}
          </ScrollView>
          <div className="space-50"></div>
        </div>
        <div className="wrapper-larg">
          <TabsViewFour
            headers={businessPageData.timeLine.headers}
          >
            {businessPageData.timeLine.data.map((item, index) => (
              <div key={index} className="time-line-content">
                {item}
              </div>
            ))}
          </TabsViewFour>
        </div>
        <div className="wrapper-small">
          <p className="text-paragraph">{businessPageData.timeLine.paragraph}</p>
        </div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <div className="space-50"></div>
        <Footer withBlogs={false}/>
      </div>
    </div>
    </main>
  )
}

export default BusinessStartegyPage